<div class="row">
    <div class="col-xs-12">
        <ui-figure-caption>
            <ui-figure-text>
                <h4>Ungskogens trädslagssammansättning, stammar/ha <br />Medelvärde för de tre senaste inventeringarna</h4>
            </ui-figure-text>
        </ui-figure-caption>
        <app-ui-table border-top right-aligned [tableConfig]="tableConfig" [tableContent]="tableContent" [caption]="tableCaption"> </app-ui-table>
        <div class="asterisk-container" *ngIf="showAsteriskTextTall">
            <b>*</b> Siffran bör tolkas med försiktighet då arealen föryngrad med tall utgör mindre än 20 procent av den totala föryngrade arealen.
        </div>
        <div class="asterisk-container" *ngIf="showAsteriskTextGran">
            <b>**</b> Siffran bör tolkas med försiktighet då arealen föryngrad med gran utgör mindre än 20 procent av den totala föryngrade arealen.
        </div>
    </div>
</div>
